import { Component, Input, TemplateRef } from '@angular/core';
import { ProviderName, WorksheetItem, WorksheetService, WorksheetType } from '@fgb/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { firstValueFrom } from 'rxjs';
import { trigger, transition, style, animate } from '@angular/animations';

@Component({
  selector: 'fgb-worksheet-item',
  templateUrl: './worksheet-item.component.html',
  styleUrls: ['./worksheet-item.component.scss'],
  animations: [
    trigger('zoomAnimation', [
      transition(':enter', [
        style({ transform: 'scale(0.1)' }),
        animate('0.6s ease', style({ transform: 'scale(1)' })),
      ]),
    ]),
  ],
})
export class WorksheetItemComponent {
  @Input({ required: true }) worksheetItem!: WorksheetItem;
  @Input({ required: true }) worksheetId!: number;

  readonly worksheetType = WorksheetType;
  readonly providerName = ProviderName;

  isDownloading = false;

  constructor(
    private readonly worksheetService: WorksheetService,
    private readonly modalService: NgbModal
  ) {}

  async getDownload(worksheetId: number, worksheetItemId: number): Promise<void> {
    if (this.isDownloading) return;

    this.isDownloading = true;

    try {
      const response = await firstValueFrom(
        this.worksheetService.downloadWorksheet(worksheetId, worksheetItemId)
      );

      const url = window.URL.createObjectURL(
        new Blob([response], { type: response.type })
      );

      try {
        const anchor = Object.assign(document.createElement('a'), {
          href: url,
          download: worksheetItemId.toString(), // TODO: use worksheet item name
        });
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
      } finally {
        window.URL.revokeObjectURL(url);
      }
    } finally {
      this.isDownloading = false;
    }
  }

  openGalleryImage(content: TemplateRef<unknown>): NgbModalRef {
    const ref = this.modalService.open(content, {
      centered: true,
      windowClass: 'open-gallery-image-modal',
      backdropClass: 'open-gallery-image-modal-backdrop',
      keyboard: true, // Escape closes the modal
    });

    ref.shown.subscribe(() => {
      const closeBtn = document.querySelector<HTMLButtonElement>(
        '.gallery-modal_close'
      );
      closeBtn?.focus();
    });

    return ref;
  }
}
